import { Assigned, QueryGroup } from '../../services/types/Operation';

class FilterConfig {
  queryGroup: QueryGroup;

  assigned: Assigned;

  subqueryType: string | null;

  sortField = 'Number';

  sortDescending = false;

  hideColumns: string[];

  removeColumns: string[];

  constructor(
    queryGroup: QueryGroup,
    assigned: Assigned,
    subqueryType: string | null,
    hideColumns: string[],
    removeColumns: string[]
  ) {
    this.queryGroup = queryGroup;
    this.assigned = assigned;
    this.subqueryType = subqueryType;
    this.hideColumns = hideColumns;
    this.removeColumns = removeColumns || [];
  }
}

export default FilterConfig;
